import { uuid, isEmpty } from "@/utils/utils";
import { stringifyCanvasAllData } from "@/utils/canvasPageLoader";

/** 工程 panel_data 入库/预览前统一补全缺省字段（与 VisualDrag.handleInitData 一致） */
export function normalizeCanvasAllDataString(data) {
  let dataObj = {};
  try {
    if (typeof data === "object" && data !== null) {
      dataObj = data;
    } else {
      dataObj = JSON.parse(data || "{}") || {};
    }
  } catch (e) {
    return stringifyCanvasAllData({});
  }
  Object.keys(dataObj).forEach((pageId) => {
    const pageData = dataObj[pageId];
    if (!Array.isArray(pageData)) {
      return;
    }
    pageData.forEach((item, ind) => {
      if (!item || typeof item !== "object") {
        return;
      }
      if (!item.style || typeof item.style !== "object") {
        dataObj[pageId][ind].style = {};
      }
      const style = dataObj[pageId][ind].style;
      style.opacity = isEmpty(style.opacity) ? 1 : style.opacity;
      style.zIndex = isEmpty(style.zIndex) ? ind + 1 : style.zIndex;
      if (item.component === "v-button") {
        if (!style.backgroundType) {
          style.backgroundType = style.backgroundImage ? "icon" : "color";
        }
        if (!style.pressBackgroundType) {
          style.pressBackgroundType = style.pressBackgroundImage ? "icon" : "color";
        }
        if (!style.btnIcon) {
          style.btnIcon = "";
        }
        if (!item.events || typeof item.events !== "object") {
          dataObj[pageId][ind].events = {};
        }
        if (!dataObj[pageId][ind].events.clickEvent) {
          dataObj[pageId][ind].events.clickEvent = { comp: "", event: "" };
        }
      } else if (item.component === "Back") {
        if (!style.isShowMenu) {
          style.isShowMenu = "true";
        }
      } else if (item.component === "StatusLight") {
        const devices =
          item.passiveMonitorConfig && item.passiveMonitorConfig.devices;
        if (Array.isArray(devices)) {
          devices.forEach((deviceItem, deviceInd) => {
            const deviceCalls = deviceItem && deviceItem.deviceCalls;
            if (deviceCalls && deviceCalls.length !== 0) {
              deviceCalls.forEach((deviceCallItem, deviceCallInd) => {
                if (!deviceCallItem.enterSpaceName) {
                  dataObj[pageId][ind].passiveMonitorConfig.devices[deviceInd].deviceCalls[
                    deviceCallInd
                  ].enterSpaceName = "0";
                }
              });
            }
          });
        }
      } else if (item.component === "Video") {
        if (!item.events) {
          dataObj[pageId][ind].events = {
            instructionDatas: [{ time: "", instructions: [], id: new Date().valueOf() }],
          };
        } else if (!item.events.instructionDatas) {
          dataObj[pageId][ind].events.instructionDatas = [
            { time: "", instructions: [], id: new Date().valueOf() },
          ];
        }
      }
      if (item.component !== "Back") {
        if (!item.componentLinks) {
          dataObj[pageId][ind].componentLinks = {
            links: [
              {
                id: uuid(),
                comp: "",
                listenEvent: "",
                changeAttrs: [{ id: uuid(), key: "", value: undefined }],
              },
            ],
            transitionTime: "",
          };
        }
      }
    });
  });
  return stringifyCanvasAllData(dataObj);
}
